import React from "react";
import Collapsible from "react-collapsible";
import { checkTranslation, conditionalWidth, translate } from "../../../utils/useful";
import { diagramComponents, diagramGroups } from "../../../variables/diagramFunctions";
import FormViewer from "../../FormViewer";
import SidebarView from "../../SidebarView";
import ButtonAnimated from "../../buttons/ButtonAnimated";
import PermissionsView from "../../PermissionsView";

class DiagramComponentConfig extends React.Component {

    state = {

        // closedGroups: {},
        // showChildsSide: false,
        // sideOpen: false,
    }

    // open = () => {
    //     this.openSidebar()
    // }
    componentDidMount() {

    }
    close = () => {
        this.closeSidebar()
    }

    openSidebar = () => {
        this.sidebarView.openSidebar()
        // this.setState({ sideOpen: true })
    }

    closeSidebar = () => {

        this.sidebarView.closeSidebar()
        // this.setState({ sideOpen: false })
    }

    saveForm = () => {
        let data = this.form.getForm()
        // console.log('form is', data)
        
        // return
        // return
        // console.log(data)
        // return
        if (data) {
            this.props.saveConfig(data, this.props.currentComponent)
            // this.close()
        }
    }

   


    render() {

        return (
            // <div className="">


            <SidebarView width={this.props.width} ref={el => this.sidebarView = el} widthCondition={{ xs: "90%", sm: '80%', md: '350px', lg: "350px", xl: "350px" }}>

                <div className="digramSidePanelList formItems-container  scroll-no-scrollbar h-100 w-100 ">
                    <div className="flexcb px-2 py-1 w-100" style={{ position: 'sticky', top: 0, zIndex: 2, borderBottom: '1px solid #eee', backgroundColor: '#fff' }}>
                        <div className="flexc w-80  py-1 px-2">
                            <div className="flexcc br-4 text-big color-white text-bold" style={{ height: 22, width: 22, background: this.props.colors?.background ?? 'linear-gradient(90deg, rgb(24, 77, 148), rgb(36, 106, 199))' }}>
                                <p>+</p>
                            </div>
                            <p className="text-bold text-normal px-1">{(this.props.currentDiagramComponent?.title ?? translate("Configuration"))}</p>

                        </div>
                        <div className=" mld-2">
                            <div className='flexc'>
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={this.saveForm}
                                    title={checkTranslation('Save')}
                                    icon='/assets/icons/angle-right-white2.svg'
                                    textColor={this.props.colors?.textColor ?? '#000'}
                                    // invert={!this.props.colors?.iconInvert}
                                    bg={this.props.colors?.background}
                                // isLoading={this.state[prop.loader]}
                                />
                            </div>
                        </div>
                    </div>
                    {/* <div className="px-4 w-100 mb-3 flexcb py-2" style={{ backgroundColor: '#fff', position: 'sticky', top: 0, borderBottom: 'solid 1px rgba(216, 216, 216, 0.2)' }}>
                        {console.log('this.props.currentDiagramComponent', this.props)}
                        <p className="text-semibold text-normal black w-100 mb-1">{checkTranslation(this.props.currentDiagramComponent?.title)}</p>

                        <p onClick={() => this.saveForm()} className="text-small  cursor-pointer" style={{ color: '#007aff' }}>{translate('Save')}</p>
                    </div> */}

                    <div className="px-1 pt-3 w-100 pb-5">
                        {/* {console.log('this.props.variablesthis.props.variables',this.props.variables)} */}
                        <FormViewer ref={el => this.form = el} params={this.props.optionsList} optionsList={this.props.optionsList} variables={this.props.variables} headers={this.props?.headers} initData={this.props.initData} errors={this.state.errors} formClass={"bordered-form"} inputClass={'bordered-input'} liveChange={this.props.liveChange} isEditing={false} width={this.props.width} />
                    </div>
                    
                    {/* {this.props.initData?.permissionsType == 'custom' && (
                        <div>
                            <div className='px-3'>
                                <p className='text-semibold text-normal'>{translate("Stage Permissions")}</p>
                                <p className=' text-smaller mt-1 color-gray-2' style={{ maxWidth: 500 }}>{translate("The following permissions will be applied for the selected stage. Default permission is based on the collection permissions.")}</p>
                            </div>
                            <PermissionsView frames={this.props.frames} width={this.props.width} admins={this.props.initData?.admins} setAdmins={this.props.setAdmins} permissionsObject={this.state.permissionsObject} setPermissionsObject={this.setPermissionsObject} type={'stage'} stage={this.props.initData} variables={this.props.variables} className={"px-3 mt-3"} />

                        </div>
                    )} */}

                </div>

            </SidebarView >


            // <div onClick={() => { this.closeSidebar() }} className={'position-fixed top-0 left-0 w-100 h-100 fadein ' + (this.state.sideOpen ? '' : 'd-none')} style={{ zIndex: 10, backgroundColor: '#10101040' }}>

            // </div>




        )
    }
}



export default DiagramComponentConfig;
